import type { ReactNode } from 'react';
import { Button, EmptyState } from '@vd/ui';

/** The filters narrowing the board, named, and how to clear them (see activeFilters.ts). */
export interface BoardFilters {
  names: string[];
  onClear: () => void;
}

/**
 * What Cards and Table show with no tickets to show (TOADO-976).
 *
 * When filters hid everything it names them and clears them in place, without
 * a reload: after moving a filtered set of tickets out of the filter's column,
 * the view is legitimately empty, and a generic "no tickets" read as a board
 * that had broken. With nothing filtered it says the project has none. A
 * view given no filters at all (Table embedded elsewhere) keeps its old words.
 */
export function BoardViewEmpty({ icon, filters, screen, className }: {
  icon: ReactNode;
  filters?: BoardFilters;
  screen?: string;
  className?: string;
}) {
  if (filters && filters.names.length > 0) {
    return (
      <div className={className} data-toado-view={screen} data-testid="board-filtered-empty">
        <EmptyState
          icon={icon}
          title="No tickets match these filters"
          description={`Filtered by ${filters.names.join(', ')}.`}
          action={<Button variant="secondary" size="sm" onClick={filters.onClear}>Clear filters</Button>}
        />
      </div>
    );
  }
  return (
    <div className={className} data-toado-view={screen} data-testid="board-empty">
      {filters ? (
        <EmptyState
          icon={icon}
          title="No tickets yet"
          description="Tickets from the extension, the widget or New ticket show up here."
        />
      ) : (
        <EmptyState
          icon={icon}
          title="No tickets match these filters"
          description="Try clearing quick filters or switching views."
        />
      )}
    </div>
  );
}
